export const ACCESS_TOKEN_NAME = 'foto-token'